"use client"

import * as React from "react"
import { CheckCircle2, AlertTriangle, Info } from "lucide-react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

function getToastIcon(
  variant: string | undefined,
  title: React.ReactNode,
  description: React.ReactNode
) {
  const titleText = typeof title === "string" ? title.toLowerCase() : ""
  const descriptionText = typeof description === "string" ? description.toLowerCase() : ""
  const text = `${titleText} ${descriptionText}`
  const errorKeywords = [
    "erro",
    "falha",
    "invalido",
    "inválido",
    "excede",
    "não permitido",
    "nao permitido",
    "expirou",
    "autentic",
    "limite atingido",
  ]

  if (variant === "destructive" || errorKeywords.some((keyword) => text.includes(keyword))) {
    return <AlertTriangle className="h-4 w-4 text-red-500 mt-0.5 shrink-0" aria-hidden="true" />
  }

  if (text.includes("sucesso") || text.includes("conclu") || text.includes("salvo")) {
    return <CheckCircle2 className="h-4 w-4 text-emerald-500 mt-0.5 shrink-0" aria-hidden="true" />
  }

  return <Info className="h-4 w-4 text-blue-500 mt-0.5 shrink-0" aria-hidden="true" />
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={3000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const icon = getToastIcon(props.variant, title, description)

        return (
          <Toast key={id} {...props}>
            <div className="flex items-start gap-2.5">
              {icon}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
